/**
 * Activity reports for Admin → Login Activity sessions (backend
 * routes/activity.ts): the dashboards a signed-in user opens, plus a "still
 * active" ping. Best-effort: a failed report is dropped, never shown.
 */
import { apiRequest } from './api';

export type WebActivityReport =
  | { kind: 'open'; dashboard: string }
  /** `idleSec`: seconds since the user's last input, 0–600. */
  | { kind: 'ping'; idleSec: number };

export async function postWebActivity(report: WebActivityReport): Promise<void> {
  try {
    await apiRequest('/api/activity/web', { method: 'POST', body: JSON.stringify(report) });
  } catch {
    // Not counted. Tracking must never interrupt the person using the app.
  }
}
